import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  openedModal: '',
  modalProps: {},
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.OPEN_MODAL:
      return updateObject(state, {
        openedModal: action.name,
        modalProps: action.props,
      });
    case AC.CLOSE_MODAL:
      return updateObject(state, {openedModal: ''});
    default:
      return state;
  }
};

export default modalReducer;
